import { ApiError } from '@/shared/api/client';
import type { EndorsementFinancialRuleSet } from '@/shared/api/resources';

/**
 * Apoio do endosso com efeito financeiro (P-END-2): a escrita das regras pendentes que
 * o servidor devolve no detalhe e no 409. Nada aqui calcula.
 */

/** As regras pendentes de uma acao, em uma linha. */
export function regrasEmTexto(regras: EndorsementFinancialRuleSet | undefined): string {
  return regras && regras.pending_rules.length > 0
    ? regras.pending_rules.join(', ')
    : 'regra pendente';
}

/** As regras pendentes que o servidor devolveu no 409, quando ha. */
export function regrasDoErroDoEndosso(erro: unknown): string[] {
  if (!(erro instanceof ApiError)) return [];
  const regras = erro.details?.pending_rules;
  return Array.isArray(regras)
    ? regras.filter((r): r is string => typeof r === 'string')
    : [];
}
